module.exports = __webpack_public_path__ + "img/background-backup.e502f1ea.jpeg";